"use strict";
/**
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [https://neo4j.com]
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FSM = void 0;
var FSM = /** @class */ (function () {
    function FSM() {
        var states = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            states[_i] = arguments[_i];
        }
        this.states = states;
        this.current = states[0];
    }
    FSM.prototype.onEvent = function (event, input) {
        var _a = this.current.events[event](input), nextState = _a.nextState, result = _a.result;
        this.transition(nextState);
        return result;
    };
    FSM.prototype.transition = function (stateName) {
        if (stateName != null && stateName !== this.current.name) {
            var newState = this.states.find(function (st) { return st.name === stateName; });
            if (newState == null) {
                throw new Error("Invalid state transition. State ".concat(stateName, " does not exist"));
            }
            this.current = newState;
        }
    };
    return FSM;
}());
exports.FSM = FSM;
